(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("opera-cornerstone-core", [], factory);
	else if(typeof exports === 'object')
		exports["opera-cornerstone-core"] = factory();
	else
		root["cornerstone"] = factory();
})(window, function() {
return 